<template>
    <DynamicLink
        @click="analytics.sendClickCompetitionDetails(name, subText)"
        class="contest-link"
        :path="linkUrl"
        :class="type"
    >
        <SvgIcon v-if="type == 'info'" :name="icon" />
        <SvgIcon v-else :name="type == 'success' ? 'win' : 'error'" />
        <span>
            {{ name }} <span class="contest-link__subtext" v-if="subText">{{ subText }}</span>
        </span>
        <SvgIcon class="right" name="chevron-right" />
    </DynamicLink>
</template>

<script lang="ts" setup>
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import { computed } from "vue";
import analytics from "@/shared/analytics";
import DynamicLink from "@/shared/components/atoms/DynamicLink.vue";

const props = defineProps<{
    linkSuffix?: string;
    type: string;
    icon: string;
    name: string;
    subText?: string;
    category?: string;
}>();

const linkUrl = computed(() => {
    if (props.category && props.category === "tipcontest") {
        return `${environment.sportBetsRootUrl}${props.linkSuffix}`;
    }

    return props.linkSuffix
        ? `${environment.sportBetsRootUrl}sazkabet-souteze/${props.linkSuffix}`
        : `${environment.sportBetsRootUrl}sazkabet-souteze`;
});
</script>
